export var DEFAULT_SEARCH_KEY = "search";